import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class ProductMarketAvailabilityForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'product-tilgængelighed', dataApiName: 'ProductMarketAvailability', text: 'Produkt tilgængelighed', textSingular: "Produkt tilgængelighed",
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      }, 
      fieldMetadata: [
        { name: 'onix', text: 'ONIX' }
      ]
    });
  }
}
